import LocalPolice from "@mui/icons-material/LocalPolice";

import { useLocation } from "react-router-dom";

import { MenuDropdown } from "../../../common-components/MenuDropdown/MenuDropdown";
import { MenuLink } from "../../../common-components/MenuLink/MenuLink";

const PreventiveLinks = ({ onClose }) => {
    const { pathname } = useLocation();

    const linksConfig = [
        {
            title: "Проф. выезды",
            active: true,
            show: true,
            link: "/Preventive",
        },
    ];

    const links = linksConfig
        .filter((l) => l.show)
        .map((link) => {
            const isCurrent =
                pathname === link.link || pathname.startsWith(link.link + "/");

            const wrapperClass =
                "menu-link-wrap" +
                (isCurrent ? " _current" : "") +
                (!link.active ? " _disabled" : "");

            return (
                <div key={link.link} className={wrapperClass}>
                    <MenuLink
                        title={link.title}
                        active={link.active}
                        show={link.show}
                        link={link.link}
                        onNavigate={onClose}
                    />
                </div>
            );
        });

    return (
        <>
            <style>{`
        .menu-link-wrap { position: relative; border-radius: 7px; padding: 7px}
        .menu-link-wrap._current {
          background-color: #ecf3ff;
        }
        .menu-link-wrap._disabled { opacity: 0.5; }
      `}</style>

            <MenuDropdown
                Icon={LocalPolice}
                title={"Проф. обследования"}
                active={true}
                links={links}
            />
        </>
    );
};

export default PreventiveLinks;